import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppConfigService, AuthService, QuickSetupIntegrationService } from "@app/core";
import { AccountService } from "@app/core/services/account.service";
import { User } from "@app/models";
import { UserService } from "@app/services";
import { ToastService } from "@app/shared/ui";
import { TranslocoService } from "@ngneat/transloco";
import { take } from "rxjs/operators";

const VERIFICATION_SENT_PARAM = "verificationSent";

@Component({
  selector: "app-verification",
  templateUrl: "./verification.component.html",
  styleUrls: ["./verification.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerificationComponent implements OnInit {
  @Input() email: string;
  sent = false;
  emailConfirmUrl: string;
  user: User;

  constructor(
    private accountService: AccountService,
    private authSvc: AuthService,
    private userSvc: UserService,
    private configSvc: AppConfigService,
    private integration: QuickSetupIntegrationService,
    private route: ActivatedRoute,
    private router: Router,
    private toastSvc: ToastService,
    private transloco: TranslocoService
  ) {}

  ngOnInit(): void {
    this.userSvc.getById(this.accountService.userId).subscribe((u) => {
      this.user = u;
      if (u.emailConfirmedDate && u.emailConfirmed) {
        this.authSvc.logout(true);
        window.location.href = "/account/auth/quick-welcome";
      }
    });

    const identityUrl = this.configSvc.appData.identityUrl;
    const returnUrl = encodeURIComponent(this.buildReturnUrl());

    this.emailConfirmUrl = `${identityUrl}/Account/SendVerificationEmail?returnUrl=${returnUrl}`;
    if (!this.email) this.email = this.accountService.user?.email;
    this.sent = !!this.accountService.user?.email_verified_date;
    if (this.accountService.user.email_verified) {
      this.integration.ensureNavigated(this.accountService.user);
    }

    this.confirmVerificationSent();
  }

  send() {
    window.location.href = this.emailConfirmUrl;
  }

  private buildReturnUrl(): string {
    const returnUrl = new URL(window.location.href);
    returnUrl.searchParams.set(VERIFICATION_SENT_PARAM, "true");

    return returnUrl.toString();
  }

  private confirmVerificationSent(): void {
    if (!this.route.snapshot.queryParamMap.has(VERIFICATION_SENT_PARAM)) {
      return;
    }

    this.sent = true;
    this.transloco
      .selectTranslate("account.email.resent")
      .pipe(take(1))
      .subscribe((message) => this.toastSvc.success(message));

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { [VERIFICATION_SENT_PARAM]: null },
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }
}
